import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';
import asyncLoadView from 'utils/asyncLoadView/asyncLoadView';
import routeArgsToInt from 'router/utils/routeArgsToInt';

const accountOrdersRoutes = [
  {
    path: 'orders',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Orders')
      },
      permissions: ['READ_ORDERS'],
      requiresComponents: ['CRM']
    },
    children: [
      {
        path: 'new',
        name: 'accountsOrdersListNew',
        component: () => asyncLoadView(import('pages/orders/AccountOrdersPage/AccountOrdersPage')),
        props: routeArgsToInt
      },
      {
        path: '',
        name: 'accountOrdersList',
        component: wrapLegacyRoute('ordersController', 'list')
      },
      {
        path: ':orderId(\\d+)',
        component: NestedRouteComponent,
        children: [
          {
            path: '',
            name: 'accountOrderDetails',
            component: wrapLegacyRoute('ordersController', 'item')
          },
          {
            path: 'periods',
            component: NestedRouteComponent,
            children: [
              {
                path: '',
                name: 'accountOrderPeriodsList',
                component: wrapLegacyRoute('orderPeriodsController', 'list')
              },
              {
                path: ':periodId(\\d+)',
                name: 'accountOrderPeriodDetails',
                component: wrapLegacyRoute('orderPeriodsController', 'item')
              }
            ]
          }
        ]
      }
    ]
  }
];

export default accountOrdersRoutes;
